export default __webpack_public_path__ + "static/STICKER ENG-0fffd7ab026642e415f20a417cf740c4.svg";